




















































import { createComponent, computed } from '@vue/composition-api'
import { getFactoryStatus, getStatusBorderColor } from '@/lib/map'
import { getFactoryTypeText } from '@/lib/factory'

import { useAppState } from '../lib/appState'
import { FactoryStatusText } from '../types'

export default createComponent({
  name: 'FactoryDetail',
  setup () {
    const [appState, { expandFactoryDetail, collapseFactoryDetail }] = useAppState()

    const images = computed(() => {
      if (appState.factoryData) {
        return appState.factoryData.images
      } else {
        return []
      }
    })

    const factoryStatus = computed(() => {
      if (appState.factoryData) {
        return getFactoryStatus(appState.factoryData)
      } else {
        return null
      }
    })

    const factoryStatusText = computed(() => {
      if (factoryStatus.value) {
        return FactoryStatusText[factoryStatus.value]?.[0] || ''
      } else {
        return ''
      }
    })

    const statusColor = computed(() => {
      if (factoryStatus.value) {
        return getStatusBorderColor(factoryStatus.value)
      } else {
        return null
      }
    })

    const factoryId = computed(() => {
      if (appState.factoryData) {
        return appState.factoryData.id
      } else {
        return ''
      }
    })

    const factoryType = computed(() => {
      if (appState.factoryData) {
        return getFactoryTypeText(appState.factoryData)
      }
    })

    const full = computed(() => appState.factoryDetailsExpanded)

    const longitude = computed(() => appState.factoryData?.lng.toFixed(7))
    const latitude = computed(() => appState.factoryData?.lat.toFixed(7))

    return {
      full,
      appState,
      images,
      expandFactoryDetail,
      collapseFactoryDetail,
      factoryStatusText,
      statusColor,
      factoryId,
      factoryType,
      longitude,
      latitude
    }
  }
})
